import React from 'react';

import styled from 'styled-components';

import { useCommunityViewContext } from 'components/View/CommunityViewContext';

import CardFooter from './CardFooter';
import { formatPrice, getDecimalParts } from '../../../utils/helpers/numbers';
import { WIDGET_TYPES } from '../constants';
import { valueFormatter } from '../DataTable/utils';
import { useWidgetContext } from '../Widget/WidgetContext';

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: end;
  height: 100%;
`;

const ValueContainer = styled.div`
  display: flex;
  align-items: flex-start;
  color: var(--text-primary);
`;

const DollarSign = styled.div`
  font-size: 20px;
`;

const Amount = styled.div`
  font-size: 42px;
  line-height: 42px;
`;

const DecimalPart = styled.span`
  font-size: 20px;
`;

interface Props {
  value?: number;
  marketValue?: number;
  footerLabel: string;
  footerDifference?: number | null;
  valueDisplay?: number;
}

const CardAverageContent = ({ value = 0, marketValue = 0, footerLabel, footerDifference, valueDisplay }: Props) => {
  const { type } = useWidgetContext();
  const { community } = useCommunityViewContext();
  const isMarketRatePerArea = WIDGET_TYPES.MARKET_RATE_SQUARE_FOOTAGE == type;
  const fixedPositions = isMarketRatePerArea ? 2 : 0;
  const formattedValue = isMarketRatePerArea
    ? valueFormatter(value, type, false, undefined, community)
    : formatPrice(Math.round(value), '', fixedPositions, fixedPositions);
  const { whole, decimal } = getDecimalParts(Number(formattedValue.replace(/,/g, '')));
  const formattedMarketValue = isMarketRatePerArea
    ? valueFormatter(marketValue ?? 0, type, true, undefined, community)
    : formatPrice(marketValue ?? 0, '$', fixedPositions, fixedPositions);

  return (
    <Content>
      <ValueContainer>
        <DollarSign>$</DollarSign>
        <Amount>
          <span>{isMarketRatePerArea ? whole : formattedValue}</span>
          {isMarketRatePerArea && <DecimalPart>{decimal}</DecimalPart>}
        </Amount>
      </ValueContainer>
      <CardFooter
        label={footerLabel}
        value={formattedMarketValue}
        positive={marketValue >= value}
        widgetType={type}
        valueDisplay={valueDisplay}
        difference={footerDifference ?? null}
      />
    </Content>
  );
};

export default CardAverageContent;
